// extracted by mini-css-extract-plugin
export var marginNegative = "_6b-5 _6b-3 _6b-1";
export var marginPositive = "_6b-4 _6b-3 _6b-1";
export var modalContent = "_6b-6";
export var samplesTable = "_6b-8";
export var samplesTableContainer = "_6b-7";
export var statBox = "_6b-a";
export var tableCell = "_6b-1";
export var tableCellCenter = "_6b-2 _6b-1";
export var tableCellRight = "_6b-3 _6b-1";
export var tableHeader = "_6b-0";
export var trackingNumber = "_6b-9";